import { Accordion } from "@fluentui/react-components";

import type { Interview } from "@aglocal/schema/Interview";
import type { DarkquellInferredSkill } from "@aglocal/schema/Darkquell";

import ConnectedDetailsAccordionItem from "./ConnectedDetailsAccordionItem";
import SkillsAccordionItem from "./SkillsAccordionItem";
import TranscriptAccordionItem from "./TranscriptAccordionItem";
import { PredictionResponse } from "@aglocal/schema/SkillClassifier";

export interface PostMeetingAccordionProps {
  interview: Interview;
  skills: readonly DarkquellInferredSkill[];
  negativeSkills: readonly PredictionResponse[];
}

export default function PostMeetingAccordion({
  interview,
  skills,
  negativeSkills,
}: PostMeetingAccordionProps) {
  return (
    <Accordion defaultOpenItems={["transcript"]} multiple>
      <ConnectedDetailsAccordionItem
        name="connected-details"
        interview={interview}
      />
      <SkillsAccordionItem
        name="skills"
        skills={skills}
        negativeSkills={negativeSkills}
      />
      <TranscriptAccordionItem
        name="transcript"
        interview={interview}
        skills={skills}
      />
    </Accordion>
  );
}
